import './chat-loading-skeleton.css';

export default function ChatLoadingSkeleton() {
  return (
    <div className="chat-loading-skeleton" role="status" data-testid="chat-loading-skeleton">
      <span className="sr-only">Loading messages…</span>
      <div className="chat-loading-skeleton-content" aria-hidden="true">
        <div className="chat-loading-skeleton-date" />
        {['received', 'received short', 'sent', 'sent short', 'received'].map((variant, index) => (
          <div className={`chat-loading-skeleton-row ${variant}`} key={index}>
            {!variant.startsWith('sent') && <div className="chat-loading-skeleton-avatar" />}
            <div className="chat-loading-skeleton-bubble">
              <span /><span />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
